import { render, staticRenderFns } from "./DashboardSidebar.vue?vue&type=template&id=4c8b428e&"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSidebar.vue?vue&type=style&index=0&id=4c8b428e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports